/**
 * Linear Bundle Functionality
 * Handles flooring + underlay bundle for linear products
 * Underlay coverage: 1 underlay = 15 sqm coverage
 */

const LINEAR_UNDERLAY_COVERAGE = 15; // 1 underlay covers 15 sqm

// Show bundle option for linear products
function showLinearBundleOption(flooringQuantity, totalArea) {
    if (typeof window.bundleData === 'undefined') {
        console.log('No bundle data available');
        return;
    }
    
    const bundleContainer = document.getElementById('flooringBundle');
    if (!bundleContainer) {
        console.log('Bundle container not found');
        return;
    }
    
    // Calculate underlay quantity: 1 underlay per 15 sqm
    // Round up to ensure full coverage
    const underlayQuantity = Math.ceil(totalArea / LINEAR_UNDERLAY_COVERAGE);
    
    console.log('Linear bundle calculation:', {
        totalArea: totalArea,
        flooringQuantity: flooringQuantity,
        underlayQuantity: underlayQuantity,
        coverageRatio: LINEAR_UNDERLAY_COVERAGE
    });
    
    // Update bundle quantities display
    const flooringQtyEl = document.getElementById('bundleFlooringQuantity');
    const underlayQtyEl = document.getElementById('bundleUnderlayQuantity');
    
    if (flooringQtyEl) flooringQtyEl.textContent = flooringQuantity;
    if (underlayQtyEl) underlayQtyEl.textContent = underlayQuantity;
    
    // Get flooring price (price per sqm * quantity)
    const flooringPricePerUnit = window.bundleData.flooringPrice / 100;
    const flooringTotal = flooringQuantity * flooringPricePerUnit;
    
    // Get underlay price
    const underlayPricePerUnit = window.bundleData.underlayPrice / 100;
    const underlayTotal = underlayQuantity * underlayPricePerUnit;
    
    // Calculate totals
    const individualTotal = flooringTotal + underlayTotal;
    
    // Apply discount to underlay
    const discountPercentage = window.bundleData.bundleDiscountPercentage || 0;
    const underlayDiscountAmount = Math.floor(underlayTotal * (discountPercentage / 100) * 100) / 100;
    const discountedUnderlayTotal = underlayTotal - underlayDiscountAmount;
    const bundleTotal = flooringTotal + discountedUnderlayTotal;
    
    console.log('Linear bundle pricing:', {
        flooringPricePerUnit: flooringPricePerUnit,
        flooringTotal: flooringTotal,
        underlayPricePerUnit: underlayPricePerUnit,
        underlayTotal: underlayTotal,
        discountPercentage: discountPercentage,
        underlayDiscountAmount: underlayDiscountAmount,
        bundleTotal: bundleTotal
    });
    
    // Update pricing display
    const flooringPriceEl = document.getElementById('bundleFlooringPrice');
    const underlayPriceEl = document.getElementById('bundleUnderlayPrice');
    const underlayPriceDiscountedEl = document.getElementById('bundleUnderlayPriceDiscounted');
    const individualTotalEl = document.getElementById('bundleIndividualTotal');
    const discountEl = document.getElementById('bundleDiscount');
    const bundleTotalEl = document.getElementById('bundleTotal');
    const savingsAmountEl = document.getElementById('bundleSavingsAmount');
    
    if (flooringPriceEl) flooringPriceEl.textContent = '£' + flooringTotal.toFixed(2);
    
    if (discountPercentage > 0) {
        // Show original price struck through and discounted price
        if (underlayPriceEl) {
            underlayPriceEl.textContent = '£' + underlayTotal.toFixed(2);
            underlayPriceEl.style.display = 'block';
        }
        if (underlayPriceDiscountedEl) {
            underlayPriceDiscountedEl.textContent = '£' + discountedUnderlayTotal.toFixed(2);
            underlayPriceDiscountedEl.style.display = 'block';
        }
    } else {
        // No discount - show regular price
        if (underlayPriceEl) {
            underlayPriceEl.textContent = '£' + underlayTotal.toFixed(2);
            underlayPriceEl.style.textDecoration = 'none';
            underlayPriceEl.style.color = '#3D4E5F';
        }
        if (underlayPriceDiscountedEl) {
            underlayPriceDiscountedEl.style.display = 'none';
        }
    }
    
    if (individualTotalEl) individualTotalEl.textContent = '£' + individualTotal.toFixed(2);
    if (discountEl) discountEl.textContent = '-£' + underlayDiscountAmount.toFixed(2);
    if (bundleTotalEl) bundleTotalEl.textContent = '£' + bundleTotal.toFixed(2);
    if (savingsAmountEl) savingsAmountEl.textContent = '£' + underlayDiscountAmount.toFixed(2);
    
    // Store quantities for cart addition
    window.bundleData.calculatedFlooringQuantity = flooringQuantity;
    window.bundleData.calculatedUnderlayQuantity = underlayQuantity;
    
    // Show the bundle container
    bundleContainer.style.display = 'block';
    
    // Scroll to bundle
    bundleContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
}

// Hide bundle
function hideLinearBundle() {
    const bundleContainer = document.getElementById('flooringBundle');
    if (bundleContainer) {
        bundleContainer.style.display = 'none';
    }
}

// Add bundle to cart (flooring + underlay)
function addLinearBundleToCart() {
    if (typeof window.bundleData === 'undefined') {
        console.error('Bundle data not available');
        return;
    }

    const flooringQuantity = window.bundleData.calculatedFlooringQuantity || 1;
    const underlayQuantity = window.bundleData.calculatedUnderlayQuantity || 1;

    // Get width, length value and variant SKU from current variant
    const widthSelect = document.getElementById('linearWidthSelect');
    const widthValue = widthSelect ? widthSelect.value : '0';
    const lengthInput = document.getElementById('linearLengthInput');
    const lengthValue = lengthInput ? lengthInput.value : '0';
    const variant = window.linearProductData?.currentVariant;
    const variantSku = variant?.sku || '';
    const bundleId = Date.now().toString();

    const items = [
        {
            id: window.bundleData.flooringVariantId,
            quantity: flooringQuantity,
            properties: {
                '_bundle': 'flooring-underlay',
                '_bundle_id': bundleId,
                '_bundle_type': 'flooring',
                '_bundle_category': 'carpet',
                '_bundle_discount': window.bundleData.bundleDiscountPercentage,
                '_bundle_total_discount': document.getElementById('bundleDiscount')?.textContent ?? '0',
                'SKU': variantSku,
                'Width (m)': widthValue,
                'Length (m)': lengthValue,
                '_cut_id': bundleId
            }
        },
        {
            id: window.bundleData.underlayVariantId,
            quantity: underlayQuantity,
            properties: {
                '_bundle': 'flooring-underlay',
                '_bundle_id': bundleId,
                '_bundle_type': 'underlay',
                '_bundle_category': 'carpet',
                '_bundle_discount': window.bundleData.bundleDiscountPercentage,
                '_bundle_total_discount': document.getElementById('bundleDiscount')?.textContent ?? '0'
            }
        }
    ];

    // Show loading state
    const addButton = document.getElementById('addBundleToCart');
    if (addButton) {
        addButton.disabled = true;
        addButton.innerHTML = 'Adding...';
    }

    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: items })
    })
    .then(response => response.json())
    .then(data => {
        console.log('Bundle cart response:', data);

        // Check if there's an actual error in the response
        // Shopify returns numeric status codes (e.g., 422) or status: 'error'
        if (data.status && (data.status === 'error' || (typeof data.status === 'number' && data.status >= 400))) {
            throw new Error(data.message || data.description || 'Failed to add to cart');
        }

        return data;
    })
    .then(data => {
        // Show success message
        if (typeof showCartSuccessToast === 'function') {
            const bundleTotal = document.getElementById('bundleTotal')?.textContent || '';
            showCartSuccessToast(1, `Bundle: ${window.bundleData.flooringProductTitle} + ${window.bundleData.underlayProductTitle} (${bundleTotal})`);
        } else {
            // Fallback success notification
            console.log('Bundle added successfully!');
        }

        // Hide bundle
        hideLinearBundle();

        // Dispatch cart update event
        document.dispatchEvent(new CustomEvent('cart:update', { detail: data }));

        // Dispatch cart:item-added event to open cart drawer
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: data }));

        // Reset button
        if (addButton) {
            addButton.disabled = false;
            addButton.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg> Add Flooring + Underlay (Best Value)';
        }
    })
    .catch(error => {
        console.error('Error adding bundle to cart:', error);
        alert('Error adding to cart: ' + error.message);

        // Reset button
        if (addButton) {
            addButton.disabled = false;
            addButton.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg> Add Flooring + Underlay (Best Value)';
        }
    });
}

// Add just flooring (no underlay)
function addLinearJustFlooringFromBundle() {
    if (typeof window.bundleData === 'undefined') {
        console.error('Bundle data not available');
        return;
    }
    
    const flooringQuantity = window.bundleData.calculatedFlooringQuantity || 1;
    
    // Get width, length value and variant SKU from current variant
    const widthSelect = document.getElementById('linearWidthSelect');
    const widthValue = widthSelect ? widthSelect.value : '0';
    const lengthInput = document.getElementById('linearLengthInput');
    const lengthValue = lengthInput ? lengthInput.value : '0';
    const variant = window.linearProductData?.currentVariant;
    const variantSku = variant?.sku || '';

    // Show loading state
    const justFlooringBtn = document.querySelector('.linear-bundle-secondary-btn');
    if (justFlooringBtn) {
        justFlooringBtn.disabled = true;
        justFlooringBtn.innerHTML = 'Adding...';
    }

    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            id: window.bundleData.flooringVariantId,
            quantity: flooringQuantity,
            properties: {
                'SKU': variantSku,
                'Width (m)': widthValue,
                'Length (m)': lengthValue,
                '_cut_id': Date.now().toString()
            }
        })
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Failed to add to cart');
        }
        return response.json();
    })
    .then(data => {
        console.log('Flooring added to cart:', data);
        
        // Show success message
        if (typeof showCartSuccessToast === 'function') {
            showCartSuccessToast(flooringQuantity, window.bundleData.flooringProductTitle || 'Flooring');
        }
        
        // Hide bundle
        hideLinearBundle();
        
        // Dispatch cart update event
        document.dispatchEvent(new CustomEvent('cart:update', { detail: data }));
        
        // Dispatch cart:item-added event to open cart drawer
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: data }));
        
        // Reset button
        if (justFlooringBtn) {
            justFlooringBtn.disabled = false;
            justFlooringBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg> Just flooring, thanks';
        }
    })
    .catch(error => {
        console.error('Error adding flooring to cart:', error);
        alert('Error adding to cart. Please try again.');
        
        // Reset button
        if (justFlooringBtn) {
            justFlooringBtn.disabled = false;
            justFlooringBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg> Just flooring, thanks';
        }
    });
}

// Toggle underlay dropdown
function toggleLinearUnderlayDropdown() {
    const dropdown = document.getElementById('underlayDropdown');
    const trigger = document.getElementById('underlaySelectorTrigger');
    
    if (dropdown && trigger) {
        const isOpen = dropdown.style.display !== 'none';
        dropdown.style.display = isOpen ? 'none' : 'block';
        trigger.classList.toggle('open', !isOpen);
    }
}

// Select underlay option
function selectLinearUnderlay(element) {
    const productId = element.dataset.id;
    const variantId = element.dataset.variant;
    const price = parseInt(element.dataset.price);
    const image = element.dataset.image;
    const title = element.dataset.title;
    
    // Update bundle data
    window.bundleData.underlayProductId = productId;
    window.bundleData.underlayVariantId = variantId;
    window.bundleData.underlayPrice = price;
    
    // Update selector display
    const selectorImage = document.getElementById('underlaySelectorImage');
    const selectorTitle = document.getElementById('underlaySelectorTitle');
    const bundleUnderlayImage = document.getElementById('bundleUnderlayImage');
    
    if (selectorImage) selectorImage.src = image;
    if (selectorTitle) selectorTitle.textContent = title;
    if (bundleUnderlayImage) bundleUnderlayImage.src = image;
    
    // Close dropdown
    const dropdown = document.getElementById('underlayDropdown');
    const trigger = document.getElementById('underlaySelectorTrigger');
    if (dropdown) dropdown.style.display = 'none';
    if (trigger) trigger.classList.remove('open');
    
    // Recalculate pricing with new underlay
    const totalArea = parseFloat(document.getElementById('totalArea')?.textContent) || 0;
    const flooringQuantity = window.bundleData.calculatedFlooringQuantity || Math.ceil(totalArea);
    
    showLinearBundleOption(flooringQuantity, totalArea);
}

// Close dropdown when clicking outside
document.addEventListener('click', function(event) {
    const dropdown = document.getElementById('underlayDropdown');
    const trigger = document.getElementById('underlaySelectorTrigger');
    
    if (dropdown && trigger) {
        if (!trigger.contains(event.target) && !dropdown.contains(event.target)) {
            dropdown.style.display = 'none';
            trigger.classList.remove('open');
        }
    }
});
